import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import { Pane } from '@leverege/ui-elements';
function ObjectEditor(props) {
  const {
    attr,
    onChange,
    data
  } = props;
  const value = attr.get(data);

  // const [ newValue, setNewValue ] = useState( JSON.stringify( value, null, 2 ) )

  // useEffect( () => {
  //   setNewValue( JSON.stringify( value, null, 2 ) )
  // }, [ value ] )

  const onEditorChange = newVal => {
    try {
      const newParsedValue = JSON.parse(newVal);
      onChange({
        value: newParsedValue,
        data: {
          attribute: attr
        }
      });
    } catch (err) {
      console.warn('we should fail validation here..');
    }
  };
  return /*#__PURE__*/React.createElement(Pane, {
    style: {
      width: '100%',
      height: '300px'
    }
  }, /*#__PURE__*/React.createElement(Editor, {
    style: {
      fontFamily: 'monospace',
      flex: 1
    },
    defaultLanguage: "json",
    width: "100%",
    height: "100%",
    theme: "light",
    value: JSON.stringify(value, null, 2),
    onChange: onEditorChange
  }));
}
const type = 'object';
export default {
  type,
  editor: ObjectEditor
};